<template>
  <div v-show="loggedUser" v-if="$auth.ready()">
    <v-toolbar dark color="primary">
      <v-toolbar-side-icon v-on:click="$router.push('/home')"><v-icon>home</v-icon></v-toolbar-side-icon>
      <div>
        <v-toolbar-title style="cursor: pointer;" class="white--text" v-on:click="$router.push('/home')">
          {{ $t('navbar.TITLE') }}
        </v-toolbar-title>
        {{ $t('navbar.SUBTITLE') }}
      </div>
      <v-spacer></v-spacer>
      {{ $route.currentRoute }}
      <v-btn round flat v-on:click="$router.push('/profile')">
        <div class="hidden-xs-only">{{ username }}</div>
        <v-icon right>person</v-icon>
      </v-btn>
      <v-btn icon @click.native.stop="dialogLogout = true">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-dialog v-model="dialogLogout" max-width="300px">
      <v-card>
        <v-card-title class="headline">{{ $t('navbar.logout.TITLE') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="darken-1" flat="flat" @click.native="dialogLogout = false">{{ $t('navbar.logout.CANCEL') }}</v-btn>
          <v-btn class="red--text darken-1" flat="flat" @click.native="logout">{{ $t('navbar.logout.OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHelp" lazy persistent scrollable max-width="70%">
      <v-card>
        <v-card-title class="headline">{{ $t('popups.'+this.dialogKey+'.TITLE', this.$auth.user().version) }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text v-if="!isExtendible(this.dialogKey)" v-html="$t('popups.'+this.dialogKey+'.BODY', this.$auth.user().version)">
        </v-card-text>

        <v-card-text v-else style="height: calc(100vh - 153px); max-height: 400px">
          <p v-html="$t('popups.'+this.dialogKey+'.EXPLANATION', this.$auth.user().version)"></p>
          <v-expansion-panel expand>
            <v-expansion-panel-content v-for="(item, i) in $t('popups.'+this.dialogKey+'.BODY', this.$auth.user().version)" :key="i">
              <div slot="header" v-html="item.TITLE"></div>
              <v-card>
                <v-card-text class="grey lighten-3" v-html="item.EXTENT"></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="dialogHelp = false">{{ $t('popups.'+this.dialogKey+'.CLOSE_BUTTON', this.$auth.user().version) }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import auth from '../../auth'
  import {PopupResource} from '../../api/popup'
  import {LanguageResource} from '../../api/language'
  export default {
    name: 'navigationBar',
    data () {
      return {
        loggedUser: auth.isAuth(this),
        languages: [

        ],
        popups: [],
        username: this.$auth.user().username,
        drawer: {
          isOn: true
        },
        dialogLogout: false,
        dialogHelp: false,
        dialogKey: 'FEATURES'
      }
    },
    mounted: function () {
      this.$auth.fetch({
        success: function () { this.username = this.$auth.user().username }
      })
    },
    created: function () {
      PopupResource().get({id: 'all'}).then(response => {
        this.popups = response.body
      }, response => {
        console.log(response)
      })
      LanguageResource().get({id: this.$auth.user().defaultLanguageId}).then(response => {
        this.$locale.change(response.body.shortname)
      }, response => {
        console.log(response)
      })
    },
    methods: {
      logout () {
        this.dialogLogout = false
        auth.logout(this)
      },
      openDialog (name) {
        this.dialogKey = name
        this.dialogHelp = true
      },
      isExtendible (name) {
        if (this.popups.length > 0) {
          var namedPopup = this._.find(this.popups, function (i) {
            return i.name === name
          })
          return namedPopup.extendible
        }
        return false
      },
      findItemByName: function (collection, itemName) {
        return this._.find(collection, function (i) {
          return i.name === itemName
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/NavigationBar.vue